import ServiceModel from '../../models/service/ServiceModel.js';

const ServiceCollection = Backbone.Collection.extend({
  name: 'services',
  model: ServiceModel,
  isFiltered: false,
  defaults: {
    query: 'unknown',

  },

  initialize() {

  },

  filter(filter, data) {
    const originalData = [];
    let filteredData = [];
    const filteredByServiceName = [];
    const fitleredByServiceType = [];
    const fitleredByServiceTypeAndName = [];
    if (filter) {
      if (filter.serviceFilter && filter.serviceFilter.toLowerCase() == 'twitteroauth') { filter.serviceFilter = 'twitter'; }
      for (let i = 0; i < data.length; i++) {
        if ((filter.accountNameFilter == null && filter.serviceFilter == null) || (filter.accountNameFilter == '' && filter.serviceFilter == '')
                    || data[i].account_type == null || data[i].account_type == ''
                    || (data[i].account_type != null)) {
          // Look for matches by name and type...
          if (filter.serviceFilter != null && filter.accountNameFilter != null && data[i].account_type.toLowerCase() == filter.serviceFilter.toLowerCase() && filter.accountNameFilter.toLowerCase() == data[i].account_name.toLowerCase()) {
            fitleredByServiceTypeAndName.push(data[i]);

          // Look for matches by name...
          } else if (filter.serviceFilter == null || filter.serviceFilter == '' || data[i].account_type.toLowerCase() == filter.serviceFilter.toLowerCase() || data[i].account_type.toLowerCase().indexOf(filter.serviceFilter.toLowerCase()) == 0) {
            filteredByServiceName.push(data[i]);

          // Look for matches by type...
          } else if (filter.serviceFilter != null
                            && filter.serviceFilter.toLowerCase() == data[i].account_type.toLowerCase()) {
            fitleredByServiceType.push(data[i]);
            this.isFiltered = true;
          } else {
            originalData.push(data[i]);
          }
        } else {
          originalData.push(data[i]);
        }
      }

      let result = [];

      if (filter.removeOtherResults != null && filter.removeOtherResults == false) {
        result = filteredData.concat(originalData);
      } else if (fitleredByServiceTypeAndName.length > 0) {
        result = fitleredByServiceTypeAndName;
      } else {
        filteredData = filteredData.concat(filteredByServiceName);
        filteredData = filteredData.concat(fitleredByServiceType);
        result = filteredData;
      }
      if (result.length == 0) {
        return data;
      }

      return result;
    }

    return data;
  },

  fetchUniqueAccounts(params, succesCallback, errorCallback) {
    return Sendible.Connect.getUniqueServices(params, succesCallback, errorCallback);
  },

  sync(method, collection, options) {
    const defer = $.Deferred();
    const params = {};

    if (options.user_id) {
      params.user_id = options.user_id;
    }
    if (options.filter) params.filter = options.filter;
    if (options.type) params.type = options.type;
    if (options.category_code) params.category_code = options.category_code;
    if (options.per_page) params.per_page = options.per_page;

    // Possible methods: create, read, update, dete
    if (method == 'read') {
      Sendible.Connect.getServices(window.appConfig.applicationId, params, '', this.page, (data) => {
        _.each(data, (service) => {
          if (service.account_type && service.account_type != 'Group') {
            service.list_type = '';
          }

          if (service.account_id) {
            service.id = service.account_id;
          } else {
            service.id = service.recipient_id;
          }
        });

        if (options.filter && options.filter != '') {
          data = this.filter(options.filter, data);

          data = this.processData(data);

          options.success(data);
          defer.resolve(data);
        } else {
          data = this.processData(data);

          options.success(data);
          defer.resolve(data);
        }
      }, (data) => {
        options.error(data.error.message);
        defer.reject(data.error.message);
      });
    }

    const promise = defer.promise();
    return promise;
  },

  processData(data) {
    let newData;

    newData = this.removeDuplicatesAddRecipients(data);

    newData = _.filter(newData, (item) => {
      const typeLC = item.list_type.toLowerCase();
      return typeLC !== 'email' && typeLC !== 'sms';
    });

    return newData;
  },

  removeDuplicatesAddRecipients(data) {
    const deduplicated = [];
    const indexedIds = [];
    let currentIndex;

    data.forEach((entry) => {
      currentIndex = indexedIds.indexOf(entry.account_id);

      if (currentIndex > -1) {
        if (!deduplicated[currentIndex].extra_recipients) {
          deduplicated[currentIndex].extra_recipients = [];
        }

        deduplicated[currentIndex].extra_recipients.push(parseInt(entry.recipient_id, 10));
      } else {
        indexedIds.push(entry.account_id);
        deduplicated.push(entry);
      }
    }, this);

    return deduplicated;
  },

  clearCache() {
    const { username } = loginContext.getCurrentDetails();
    const key = `${username}_services`;
    const cache = new Cache();

    if (cache.read(key) !== null) {
      cache.remove(key);
    }
  },

  clearAllCache() {
    const cache = new Cache();
    const { username } = loginContext.getCurrentDetails();
    const key = `${username}_services`;

    cache.removeLike(key);
  },

  parse(data) {
    return data;
  },

  page: 1,

});

export default ServiceCollection;
